import { render, staticRenderFns } from "./approve-button.vue?vue&type=template&id=43095714&"
import script from "./approve-button.vue?vue&type=script&lang=js&"
export * from "./approve-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports